import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"
import AemGrid from "@/components/AemGrid"
import {
  PRODUCT_DATA_URL,
  footerUrl,
  headerUrl,
  publicWebsiteUrl,
  EMPTY_PIXEL,
  LW_APP_NAME,
} from "@/constants"
import {
  fetchGlobalConfig,
  fetchPageModel,
  fetchPageShell,
} from "@/services/server/aemPageData.server"
import { getConfig } from "@/constants/config"
import { useDispatch, useSelector } from "react-redux"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { i18n } from "next-i18next"
import useIsSsr from "@/hooks/useIsSsr"
import { useRouter } from "next/router"
import usePageAuth from "@/hooks/usePageAuth"
import {
  filterBackEndJson,
  generateCanonicalUrl,
  getClienIP,
  getDataLayerObj,
  getQuickViewAuth,
  getUserPersona,
  removeAndCleanLink,
  updateAnalyticPageUrl,
} from "@/utils/helper"
import {
  handleServerSideRouteError,
  logServerSideError,
  getUpstreamStatus,
} from "@/utils/serverSideError"
import { constructGlobalConfigPath } from "@/utils/aemGlobalConfigHelper"
import { getTeaserFragments } from "@/components/ProductDetail/v3/productDetailsHelper"
import {
  getProductDetailsFromServer,
  getProductBySkuFromServer,
  getBVReviewStatsData,
  getBVFullReviewData,
  getProductShippingDetailsFromServer,
} from "@/utils/product"
import {
  selectGenericState,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"
import { selectAuthState } from "@/store/features/authSlice"
import { selectPdpState } from "@/store/features/pdpSlice"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import ProductDetail from "@/components/ProductDetail/v3/ProductDetail"
import PairsWellWith from "@/components/PairsWellWith/PairsWellWith"
import ProductAccordion from "@/components/ProductDetail/v3/ProductAccordion"
import Review from "@/components/Review/v1/Review"
import ProductExf from "@/components/ProductDetail/v3/ProductLandingTeasers/ProductExf"
import PDPLoader from "@/components/ProductDetail/v3/PDPLoader"
import NextHead from "@/components/core/Head/NextHead"
import PDPCuratedProducts from "@/components/ProductDetail/v3/ProductDetailView/PDPCuratedProducts"
import Script from "next/script"
import { SCENE7_JS_URL } from "@/components/ImageGallery/v2/constants"
import akamaiCacheTagNormalization from "@/utils/akamaiCacheTagNormalization"

const ProductDetailsPage = props => {
  const {
    tmpData: data = {},
    headertmp: header,
    footertmp: footer,
    ip,
    globalScript,
    footerScript,
    analyticsData,
    gbhDataLayerCustom,
    slug,
    tmpSkuId: skuId,
    type,
    pdpData = {},
    initialImgAlt,
    initialImgUrl,
    initialImageFullUrl,
    fullUrl,
    isPart,
    siteName,
    seoProperties: { email = "", phoneNum = "" } = {},
    variantImages,
    reviewStatsData,
    fullReviewData,
    pdpShippingDetails,
  } = props || {}

  const {
    redirectTarget: { page: { path = "" } = {} } = {},
    language: metaLanguage = "",
  } = data

  const dispatch = useDispatch()
  const router = useRouter()
  const isSsr = useIsSsr()
  const { access_token: accessToken } = useSelector(selectAuthState)
  const { pageIsInteractive } = useSelector(selectGenericState)
  const { isTeaserLoaded, isProductExcludeFromPaidAdvertising } =
    useSelector(selectPdpState)

  const [pageRedirect, setPageRedirect] = useState("")
  const [config, setConfig] = useState({})
  const [priceSpiderKey, setPriceSpiderKey] = useState("")
  const [priceSpiderLanguage, setPriceSpiderLanguage] = useState("")
  const [priceSpiderCountry, setPriceSpiderCountry] = useState("")

  const {
    primaryBundleSKU_s: primaryBundleSKUs = "",
    productRegionAllVariantDiscontinued_b: discontinuedProduct = false,
  } = pdpData || {}

  const isBundleProduct = Boolean(primaryBundleSKUs)
  useEffect(() => {
    getConfig().then(config => setConfig(config))
    const {
      ProductLocalCategory_s: productLocalCategory = "",
      Product_Category: productCategory = "",
      CustomerFacingSKU_s: skuID = "",
      CustomerFacingBrand_s: siteName = "",
    } = pdpData
    window.needPdpdata = {
      productSubCatergory:
        productLocalCategory?.toLowerCase() || productCategory?.toLowerCase(),
      skuID,
      siteName: siteName.toLowerCase(),
    }
    if (gbhDataLayerCustom) dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => dispatch(setGbhDataLayerCustom({}))
  }, [])

  useEffect(() => {
    window.adobeTarget = window.adobeTarget || {}
    window.adobeTarget.pdp = {
      variantImages: variantImages,
    }
  }, [variantImages])

  useEffect(() => {
    if (!_isEmpty(config)) {
      const psKey = _get(config, "general.priceSpiderKey", "")
      if (psKey) {
        setPriceSpiderKey(psKey)
      }
      const psLanguage = _get(config, "internationalization.language", "")
      if (psLanguage) {
        setPriceSpiderLanguage(psLanguage)
      }
      const psCountry = _get(config, "internationalization.country", "")
      if (psCountry) {
        setPriceSpiderCountry(psCountry)
      }
    }
  }, [config])

  useEffect(() => {
    if (ip) sessionStorage.setItem("true-ip", ip)
  }, [ip])

  usePageAuth()

  useEffect(() => {
    if (analyticsData) getDataLayerObj(analyticsData)
  }, [analyticsData])

  if (
    typeof window !== "undefined" &&
    window.kohler?.datalayer?.readyState === "ready"
  ) {
    const kohlerDatalayer = window.kohler.datalayer
    if (analyticsData && kohlerDatalayer?.setItem) {
      kohlerDatalayer.setItem("PAGE_INFO", analyticsData)
    }
  }
  useEffect(() => {
    if (path) {
      setPageRedirect(removeAndCleanLink(path))
    }
  }, [path])

  useEffect(() => {
    if (!isSsr && pageRedirect) {
      router.push(pageRedirect)
    }
  }, [isSsr, pageRedirect])

  useEffect(() => {
    if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
      getTeaserFragments(data, pdpData)
    }
  }, [accessToken, pdpData, pageIsInteractive, isTeaserLoaded])

  const quickViewAuthData = getQuickViewAuth(footer)
  const productDetailKey = `${slug || pdpData?.slug_s || ""}-${
    skuId || pdpData?.masterSKU_s || ""
  }`

  return (
    <>
      <NextHead
        psKey={priceSpiderKey}
        psCountry={priceSpiderCountry}
        psLanguage={priceSpiderLanguage}
        fullUrl={fullUrl}
        metaLanguage={metaLanguage}
        pdpData={pdpData}
        reviewStatsData={reviewStatsData}
        fullReviewData={fullReviewData}
        isPart={isPart}
        initialImageFullUrl={initialImageFullUrl}
        skuId={skuId}
        siteName={siteName}
        isBundleProduct={isBundleProduct}
        persona={getUserPersona()}
        config={config}
        isProductExcludeFromPaidAdvertising={
          isProductExcludeFromPaidAdvertising
        }
        variantImages={variantImages}
        pdpShippingDetails={pdpShippingDetails}
      />
      {header ? (
        <GlobalPageHeader
          themeType={data?.appliedCssClassNames}
          header={header}
          title={pdpData?.metaTitle_s}
          description={pdpData?.metaDescription_s}
          templateName={data?.templateName}
          globalScripting={globalScript}
          isPdp={true}
          fullUrl={fullUrl}
          imageUrl={initialImageFullUrl}
          email={email}
          phone={phoneNum}
          siteName={siteName}
          data={data}
        />
      ) : null}

      <Script
        key="zoomdatapdp"
        id="zoomdatapdp"
        src={`${SCENE7_JS_URL}ZoomViewer.js`}
      />

      <Script type="text/javascript" src={`${SCENE7_JS_URL}SpinViewer.js`} />

      {data && !_isEmpty(pdpData) ? (
        <div className="min-vh-100">
          <AemGrid
            data={data}
            count={0}
            productDetail={(data, slug, skuId, type) => (
              <ProductDetail
                key={productDetailKey}
                data={data}
                pdpData={pdpData}
                slug={slug}
                skuId={skuId}
                type={type}
                initialImgAlt={initialImgAlt}
                initialImgUrl={initialImgUrl}
                analyticsData={analyticsData}
                isPart={isPart}
              />
            )}
            productDetailFiller={data => (
              <PDPLoader
                initialImgAlt={initialImgAlt}
                initialImgUrl={initialImgUrl}
                pdpJson={data}
                pdpData={pdpData}
                skuId={skuId}
              />
            )}
            pairsWellWith={data => <PairsWellWith data={data} skuId={skuId} />}
            productAccordion={data => <ProductAccordion data={data} />}
            review={data => <Review data={data} />}
            productExf={data => <ProductExf data={data} />}
            slug={slug}
            skuId={skuId}
            type={type}
            pdpCuratedProduct={data =>
              !discontinuedProduct ? (
                <PDPCuratedProducts
                  authData={data}
                  slug={slug}
                  skuId={skuId}
                  quickViewAuthData={quickViewAuthData}
                />
              ) : null
            }
          />
        </div>
      ) : null}
      {footer ? (
        <GlobalPageFooter footer={footer} footerScripting={footerScript} />
      ) : null}
    </>
  )
}

/**
 *
 * @return {Object}
 */
export async function getServerSideProps({
  req,
  res,
  resolvedUrl,
  locale,
  query,
}) {
  const { url = "" } = req
  const { leafcategory: slug = "", skuId = "", products = "" } = query
  let resolvedSlug = slug
  const isPart = products === ""
  const urlPathWithoutParams = resolvedUrl?.split("?")[0] ?? `/${locale}`
  let profileName = isPart ? `profile_service_parts_PDP` : `profile_kohler_PDP`
  let collections = isPart ? "service_parts" : "kohler"

  /**
   * * Get the path from the request
   * @type {string}
   * @param {string} url - The URL of the request
   * @param {string} locale - The locale of the request
   * @param {string} urlPathWithoutParams - The URL path without parameters
   */
  const path = constructGlobalConfigPath(
    true,
    `/${locale}${urlPathWithoutParams}`
  )

  /**
   * If the path is invalid, return notFound
   * @type {boolean}
   */
  if (path.error) {
    return {
      notFound: true,
    }
  }

  /**
   * * Fetch the global configuration data
   * @type {Object}
   * @param {string} path - The path to the global configuration
   */

  const pageModelUrl = `/${locale}${PRODUCT_DATA_URL}`
  const pageModelRequest = fetchPageModel(pageModelUrl).then(
    data => ({ data }),
    error => ({ error })
  )
  let configData = {}
  try {
    configData = (await fetchGlobalConfig(path)) || {}
  } catch (error) {
    return handleServerSideRouteError("PDP global config fetch failed", error, {
      url: path,
      slug,
    })
  }
  if (LW_APP_NAME) {
    if (!_isEmpty(configData)) {
      const { general: { serviceParts = "service_parts" } = {} } = configData
      profileName = isPart
        ? `profile_${serviceParts}_PDP`
        : `profile_${LW_APP_NAME}_PDP`
      collections = isPart ? serviceParts : LW_APP_NAME
    }
  } else {
    if (!_isEmpty(configData)) {
      const {
        general: { serviceParts = "service_parts", lwAppName = "" } = {},
      } = configData
      profileName = isPart
        ? `profile_${serviceParts}_PDP`
        : `profile_${lwAppName}_PDP`
      collections = isPart ? serviceParts : lwAppName
    }
  }
  let tmpSkuId = skuId
  await i18n?.reloadResources()
  const ip = getClienIP(req) ?? ""
  const fullUrl = generateCanonicalUrl(url, locale, publicWebsiteUrl)
  const apiStatus = 200
  const apiStatusText = ""
  const { data, error: pageModelError } = await pageModelRequest
  if (pageModelError) {
    return handleServerSideRouteError(
      "PDP page model fetch failed",
      pageModelError,
      {
        url: pageModelUrl,
        slug,
      }
    )
  }
  const {
    globalScript = "",
    footerScript = "",
    pageComponentProperties = {},
    data: rawAnalyticsData = "",
    datalayerPageName = "",
    eventPageType = "",
    headerExpFrg = "",
    footerExpFrg = "",
    siteName = "",
    topHeadScript = null,
    analyticsScriptClass = "",
    seoProperties = {},
  } = data
  const analyticsData = updateAnalyticPageUrl(rawAnalyticsData, fullUrl)
  const headerModelUrl = `${headerExpFrg ? headerExpFrg : headerUrl}.model.json`
  const footerModelUrl = `${footerExpFrg ? footerExpFrg : footerUrl}.model.json`
  const { header, footer } = await fetchPageShell({
    headerModelUrl,
    footerModelUrl,
    pageName: "PDP",
    context: {
      slug,
    },
  })
  let pdpData = {}
  let pdpShippingDetails = {}

  try {
    pdpData = await getProductDetailsFromServer(
      profileName,
      collections,
      resolvedSlug,
      locale
    )
  } catch (error) {
    return handleServerSideRouteError(
      "PDP product details fetch failed",
      error,
      {
        profileName,
        collections,
        slug: resolvedSlug,
        locale,
      }
    )
  }

  if ((_isEmpty(pdpData) || !pdpData) && skuId) {
    try {
      const skuLookupData = await getProductBySkuFromServer(
        profileName,
        collections,
        skuId,
        locale
      )

      const { slug_s: canonicalSlug = "", pdp_url_s: canonicalPdpUrl = "" } =
        skuLookupData || {}

      if (canonicalSlug && canonicalSlug !== resolvedSlug) {
        resolvedSlug = canonicalSlug
        pdpData = await getProductDetailsFromServer(
          profileName,
          collections,
          resolvedSlug,
          locale
        )

        if (!_isEmpty(pdpData) && canonicalPdpUrl) {
          const requestedPath = urlPathWithoutParams.replace(
            new RegExp(`^/${locale}(?=/|$)`),
            ""
          )
          const canonicalPath = canonicalPdpUrl.split("?")[0]

          if (requestedPath !== canonicalPath) {
            return {
              redirect: {
                destination: canonicalPdpUrl,
                permanent: false,
              },
            }
          }
        }
      }
    } catch (fallbackError) {
      logServerSideError("PDP SKU fallback lookup failed", fallbackError, {
        profileName,
        collections,
        slug,
        resolvedSlug,
        skuId,
        locale,
      })
    }
  }

  if (_isEmpty(pdpData) || !pdpData) {
    const error = new Error("PDP product details returned empty data")
    logServerSideError("PDP product details returned empty data", error, {
      profileName,
      collections,
      slug,
      resolvedSlug,
      skuId,
      locale,
    })
    throw error
  } else if (!skuId) {
    tmpSkuId = pdpData.masterSKU_s
  }

  // Call BV API's after getting pdpData
  const reviewStatsData = await getBVReviewStatsData(skuId || tmpSkuId)
  const fullReviewData = await getBVFullReviewData(skuId || tmpSkuId)
  let initialImgAlt = ""
  let initialImgUrl = ""
  let initialImageFullUrl = ""
  let tmpData = {}
  if (!_isEmpty(pageComponentProperties)) {
    tmpData = pageComponentProperties
  } else {
    tmpData = data
  }
  let variantImages = []
  if (tmpSkuId) {
    let variants = []
    if (pdpData["variantList.sku_ss"]) {
      variants = pdpData["variantList.sku_ss"]
    }
    variantImages = pdpData["productImages.labelWithUrl_ss"]
      ? pdpData["productImages.labelWithUrl_ss"]
      : []
    let variantImageLabels = []
    let variantImageURLs = []
    if (variantImages?.length) {
      const selVarImageUrls = []
      const selVarImageLabels = []
      variantImages.forEach(img => {
        const imgDetail = img.split("|")
        if (tmpSkuId === imgDetail[0]) {
          selVarImageLabels.push(imgDetail[4] ?? "")
          selVarImageUrls.push(
            imgDetail[imgDetail.length - 1]
              ? imgDetail[imgDetail.length - 1]
              : EMPTY_PIXEL
          )
        } else if (!variants.find(v => v === imgDetail[0])) {
          variantImageLabels.push(imgDetail[4] ?? "")
          variantImageURLs.push(
            imgDetail[imgDetail.length - 1]
              ? imgDetail[imgDetail.length - 1]
              : EMPTY_PIXEL
          )
        }
      })
      variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
      variantImageURLs = [...selVarImageUrls, ...variantImageURLs]
      if (variantImageURLs.length < 1) {
        variantImageLabels.push(tmpSkuId)
        variantImageURLs.push(EMPTY_PIXEL)
      }
    } else {
      variantImageLabels.push(tmpSkuId)
      variantImageURLs.push(EMPTY_PIXEL)
    }
    const assetIdArray = variantImageURLs
      ? variantImageURLs[0].split("PAWEB/")
      : [""]
    initialImgAlt = variantImageLabels[0]
    initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : ""
    initialImageFullUrl =
      variantImageURLs.find(image => image.includes(initialImgUrl)) ?? ""
  }

  try {
    const res = await getProductShippingDetailsFromServer(skuId || tmpSkuId)
    pdpShippingDetails = res?.data || {}
  } catch (error) {
    const errorData = {
      status: getUpstreamStatus(error),
      statusText: error?.response?.statusText || error?.statusText,
      code: error?.code,
      url: error?.response?.config?.url || error?.config?.url,
    }
    logServerSideError(
      "PDP shipping details SKU fallback lookup failed",
      errorData,
      {
        profileName,
        collections,
        slug,
        resolvedSlug,
        skuId,
        locale,
      }
    )
  }

  const gbhDataLayerCustom = {}
  if (datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = datalayerPageName
  }
  if (eventPageType) {
    gbhDataLayerCustom.eventPageType = eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
    const normalizedCacheTag = akamaiCacheTagNormalization(data?.pageType)
    if (normalizedCacheTag) {
      res.setHeader("Cache-Tag", normalizedCacheTag)
    }
  }
  if (data) tmpData = filterBackEndJson(tmpData)
  let headertmp
  if (header) headertmp = filterBackEndJson(header)
  let footertmp
  if (footer) footertmp = filterBackEndJson(footer)
  const metaContent = data?.metaContent ?? ""
  return {
    props: {
      ip,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      analyticsData,
      gbhDataLayerCustom,
      topHeadScript,
      analyticsScriptClass,
      slug: resolvedSlug,
      tmpSkuId,
      pdpData,
      metaContent,
      ...(await serverSideTranslations(locale, ["common"])),
      apiStatus,
      apiStatusText,
      initialImgAlt,
      initialImgUrl,
      initialImageFullUrl,
      fullUrl,
      isPart,
      siteName,
      urlPath: urlPathWithoutParams,
      seoProperties,
      variantImages,
      reviewStatsData,
      fullReviewData,
      pdpShippingDetails,
    },
  }
}
ProductDetailsPage.propTypes = {
  reviewStatsData: PropTypes.object,
  fullReviewData: PropTypes.object,
}
export default ProductDetailsPage
